module.exports = __webpack_public_path__ + "static/media/TADOlogo.699af424.png";